import React, {Component} from 'react';
import {Grid, Row, Col, Form, FormGroup, ControlLabel, FormControl} from "react-bootstrap";
import WysylkaForm from "./wysylkaComponents/WysylkaForm";
import TrasyService from "../../../konfiguracja/trasyConfig/trasy/TrasyService";


export default class WysylkaTabContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasy:[]

        }
    }

    componentDidMount() {
        this.pobierzTrasy()
    }

    pobierzTrasy(){
        TrasyService.getTrasy().then(function (response) {
            this.setState({trasy:response.data.content})
        }.bind(this))
    }

    render() {

        return (
            <div>
                <Row>
                    <Col xs={12}>
                        <WysylkaForm trasy={this.state.trasy}/>
                    </Col>
                </Row>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/komunikaty/powiadomienia/components/WysylkaTabContainer.js